/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Orders_Inspection_Updated_ToInputs */

const en_orders_inspection_updated_to = /** @type {(inputs: Orders_Inspection_Updated_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inspection updated to ${i?.status}`)
};

const es_orders_inspection_updated_to = /** @type {(inputs: Orders_Inspection_Updated_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inspeccion actualizada a ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Inspection updated to {status}" |
*
* @param {Orders_Inspection_Updated_ToInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_inspection_updated_to = /** @type {((inputs: Orders_Inspection_Updated_ToInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Inspection_Updated_ToInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_inspection_updated_to(inputs)
	return es_orders_inspection_updated_to(inputs)
});